import { useMantineTheme } from '@mantine/core';

import { useMediaQuery } from './useMediaQuery';

export const useIsSmBreakpoint = () => {
  const mantineTheme = useMantineTheme();

  return useMediaQuery(`(min-width: ${mantineTheme.breakpoints.sm}px)`);
};
